import React, { useEffect } from "react";
import "./Agency.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Agency_header from "./Agency_header/Agency_header";
import Agency_table from "./Agency_table/Agency_table";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";
import { useDispatch, useSelector } from "react-redux";
import {
  CommissionHistry,
  getCommissionDashboard,
} from "../../features/auth/Slice";

function Agency() {
  // ✅ DEFINE IT HERE
  // const promotionSectionData = {
  //   title: "Promotion Data",
  //   image: "/assets/images/icons/savings.png",
  //   stats: [
  //     { value: "0.19", label: "This Week" },
  //     { value: "657.52", label: "Total Commission" },
  //     { value: "15", label: "Direct Subordinate" },
  //     { value: "0", label: "Total No of subordinate in the team" },
  //   ],
  // };

  const dispatch = useDispatch();
  const commission_dashboard = useSelector(
    (state) => state.auth.commission_dashboard,
  );
  useEffect(() => {
    dispatch(getCommissionDashboard());
  }, [dispatch]);

  const tabListData = [
    commission_dashboard?.User
      ? {
          type: "copy",
          name: "Copy Invitation Code",
          image: "/assets/images/icons/invitation_code.png",
          value: `${commission_dashboard?.User?.refer_code}`,
        }
      : null,
    {
      type: "link",
      name: "Subordinate Data",
      image: "/assets/images/icons/calendar.png",
      link: "/subordinate-data",
    },
    // {
    //   type: "link",
    //   name: "Commission Details",
    //   image: "/assets/images/icons/doller.png",
    //   link: "/commission-details",
    // },
    {
      type: "link",
      name: "Invitation Rules",
      image: "/assets/images/icons/invitation_rule.png",
      link: "/invitation-rules",
    },
    // {
    //   type: "link",
    //   name: "Agent Line Customer Service",
    //   image: "/assets/images/icons/call_headset.png",
    //   link: "/promotion",
    // },
    // {
    //   type: "link",
    //   name: "Rebate Ratio",
    //   image: "/assets/images/icons/savings.png",
    //   link: "/rebate-ratio",
    // },
  ];

  return (
    <section className="Agency">
      <Common_white_header headingText={"Agency"} />
      <div className="container">
        <div className="commission-card">
          <Agency_header
            yesterday_reward={commission_dashboard?.yesterday_reward}
          />
          <Agency_table {...commission_dashboard} />
          <Tab_list
            listItems={tabListData}
            // promotionData={promotionSectionData}
          />

          {/* <div className="coming-soon-overlay">
            <div className="coming-soon-box">
              <div className="coming-soon-icon">🎁</div>

              <h1> 🚀 Stay tuned for upcoming updates</h1>

                            <button
                className="coming-soon-btn"
                onClick={() => window.history.back("/")}
              >
                Go Back
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Agency;
